<template>
  <div>
    <div :class="$.top_row">
      <div :style="{width: '210px'}">
        <vgp-label-slot
          :label="locales('pricing_widget_user_select_label')"
        >
          <template #body>
            <div :class="$.users_selection">
              <dropdown-select
                :drop-list="dropdownItems"
                :selected="selectedItem"
                :multiselect="false"
                :show-reset-btn="false"
                :show-selected-first="false"
                :fixed-width="280"
                item-template="text"
                track-by-text="text"
                group-by="discountGroup"
                :group-settings="{
                  divider: false,
                  color: '#808080'
                }"
                :left-icon="{
                  name: 'team',
                  type: 'regular',
                  size: 20,
                }"
                @selected="selected => $emit('changeUserCount', selected[0])"
              />
              <div
                v-if="isShowUsersSelectionNotify"
                :class="$.users_selection_notify"
                @click="onShowContactForm"
                v-html="locales('payment_user_selection_notification_for_large_teams')"
              />
            </div>
          </template>
        </vgp-label-slot>
      </div>

      <div :class="[$.swith, isAnnual ? $.annual : $.month]">
        <div
          :class="[$.tab, $.annually]"
          @click="$emit('toggleAnnual', true)"
        >
          <div :class="[$.save_item, isAnnual ? $.dnone : '']">
            <discount-svg />
          </div>
          <div>{{ locales('plans_annually_locale') }}</div>
        </div>
        <div
          :class="[$.tab, $.monthly]"
          @click="$emit('toggleAnnual', false)"
        >
          {{ locales('plans_monthly_locale') }}
        </div>
      </div>
    </div>
    <div :class="$.plan_cards">
      <payment-plan-card
        v-for="(plan, index) in plans"
        ref="card"
        :key="index"
        :plan-data="plan"
        :is-annual="isAnnual"
        :is-popup="isPopup"
        :heights="cardSectionsHeights"
        @buyPlanClick="plan => $emit('buyPlanClick', plan)"
        @upgradePlanClick="plan => $emit('upgradePlanClick', plan)"
        @setHeights="setHeights"
      />
    </div>
  </div>
</template>

<script>
import VgpLabelSlot from '../../common/VueComponents/label/vgpLabelSlot.vue';
import DropdownSelect from '../../common/VueComponents/dropdownSelect/dropdownSelect.vue';
import paymentPlanCard from './paymentPlanCard.vue';
import discountSvg from './discountSvg.vue';
import app from '../../../app';

export default {
  name: 'PaymentPlansWidget',
  components: {
    paymentPlanCard,
    DropdownSelect,
    VgpLabelSlot,
    discountSvg,
  },
  props: {
    plans: { type: Array, required: true, default: () => [] },
    usersCountList: { type: Array, required: true, default: () => [] },
    selected: { type: Object, required: true, default: () => {} },
    isPopup: { type: Boolean, required: false, default: false },
    isAnnual: { type: Boolean, required: true, default: false },
  },
  emits: {
    toggleAnnual: Boolean,
    buyPlanClick: Object,
    upgradePlanClick: Object,
  },
  data() {
    return {
      locales: __,
      cardSectionsHeights: {
        featuresSection: 0,
      },
      isShowUsersSelectionNotify: false,
    };
  },
  computed: {
    leftSidebarWidth() {
      return this.$store.getters.leftSidebarWidth;
    },
    dropdownItems() {
      return this.usersCountList.map(item => {
        if (!this.isAnnual && item.count === 1) {
          return {
            ...item,
            text: `${item.count} ${__('one_user_locale_disabled_for_monthly')}`,
          };
        }
        if (item.count >= 20) {
          return {
            ...item,
            discountGroup: __('payment_user_selection_discount_label'),
          };
        }

        return {
          ...item,
        };
      });
    },
    selectedItem() {
      return this.dropdownItems.find(item => item.id === this.selected.id);
    },
  },
  watch: {
    leftSidebarWidth() {
      this.calcHeights();
    },
    selected: {
      handler(selected) {
        if (selected.count === 40) {
          this.isShowUsersSelectionNotify = true;
        } else {
          this.isShowUsersSelectionNotify = false;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    setTimeout(() => {
      this.calcHeights();
    }, 0);
    window.addEventListener('resize', this.calcHeights);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcHeights);
  },
  methods: {
    calcHeights() {
      const paymentCrads = this.$refs.card || [];

      this.cardSectionsHeights.featuresSection = 0;

      paymentCrads.forEach(card => {
        const featuresDescription = card.$refs.featuresDesc;
        const featuresList = card.$refs.featuresList;

        const height = featuresDescription?.clientHeight + featuresList?.clientHeight;

        if (height > this.cardSectionsHeights.featuresSection) {
          this.cardSectionsHeights.featuresSection = height;
        }
      });
    },
    onShowContactForm() {
      app.trigger('messageUsForm:show', 'price-app-contact-us-form');
    },
  },
};
</script>

<style module="$" lang="less">
  @import '../../../less/_mixins.less';
  @import '../../../less/_fonts.less';
  @import '../../../less/_variables.less';

  .dnone {
    display: none;
  }

 .top_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .users_selection {
      display: flex;
      align-items: center;

      .users_selection_notify {
        white-space: nowrap;
        margin-top: -2px;
        position: relative;
        .FontLatoRegular;
        .fs(12px, 18px);
        color: #1565C0;
        padding: 8px 12px;
        border-radius: 4px;
        background: #D0E0F2;
        margin-left: 18px;

        span {
          text-decoration: underline;
          text-underline-offset: 3px;
        }

        &:hover {
          cursor: pointer;
        }

        &::before {
          content: '';
          position: absolute;
          left: -4px;
          top: 50%;
          width: 8px;
          height: 8px;
          background: #D0E0F2;
          transform: translateY(-50%) rotate(45deg);
        }
      }
    }

    .swith {
      display: flex;
      align-items: center;
      min-height: 38px;
      background:#E7EFF8;
      border-radius: 48px;
      box-sizing: border-box;
      gap:4px;
      padding:0 4px;

      .tab {
        min-width: 62px;
        padding: 0 8px;
        box-sizing: border-box;

        .FontLatoBold;
        .fs(12px, 30px);
        color: #1F1F1F;

        &.annually {
          position: relative;

          .save_item {
            position: absolute;
            top: -25px;
            right: 110%;
            min-width: max-content;
            .FontLatoRegular;
            .fs(14px, 20px);
            color: #757575;
          }
        }
      }

      &.annual {
        .tab.annually {
          .FontLatoBold;
          background: #1565C0;
          color: #FFFFFF;
          border-radius: 36px;
        }

        .tab.monthly:hover {
          color: #424242;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      &.month {
        .tab.annually {
          .save_item {
            color: @orange;

            &::after {
              border-left: 1px solid @orange;
              border-bottom: 1px solid @orange;
            }
          }

          &:hover {
            color: #424242;
            text-decoration: underline;
            cursor: pointer;
          }
        }

        .tab.monthly {
          .FontLatoBold;
          background: #1565C0;
          color: #FFFFFF;
          border-radius: 36px;
        }
      }
    }
  }

  .plan_cards {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
</style>
